import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ClarityModule } from '@clr/angular';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../../environments/environment';

/**
 * Änderungsprotokoll (broadcast audit log) — extracted from DetailsComponent.
 * Mounted lazily by the details accordion (*clrIfExpanded), so ngOnInit IS
 * the former lazy first-expand fetch; collapse destroys the component and
 * re-expand refetches a fresh first page (50 rows — cheap, fresher data).
 * Keyed by the stable broadcastKey string, so the parent's broadcast
 * reference swaps on live updates don't retrigger anything.
 */
@Component({
  selector: 'app-broadcast-audit-log',
  standalone: true,
  imports: [CommonModule, FormsModule, ClarityModule],
  templateUrl: './broadcast-audit-log.component.html',
  styleUrl: './broadcast-audit-log.component.scss',
})
export class BroadcastAuditLogComponent implements OnInit {
  @Input({ required: true }) broadcastKey!: string;

  auditEntries: any[] = [];
  auditNextToken: string | null = null;
  auditLoading = false;
  auditLoaded = false;
  auditUserOnly = false;

  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    this.fetchAudit(false);
  }

  get visibleAuditEntries(): any[] {
    if (!this.auditUserOnly) return this.auditEntries;
    return this.auditEntries.filter(e => e.actor && e.actor !== 'System' && e.actor !== 'External');
  }

  fetchAudit(append: boolean) {
    const key = this.broadcastKey;
    if (!key || this.auditLoading) return;
    this.auditLoading = true;
    let url = environment.API_Base + '/broadcast/audit-log?broadcastKey=' + encodeURIComponent(key) + '&limit=50';
    if (append && this.auditNextToken) {
      url += '&nextToken=' + encodeURIComponent(this.auditNextToken);
    }
    this.http.get<any>(url).subscribe({
      next: (page) => {
        const items = page?.items ?? [];
        this.auditEntries = append ? [...this.auditEntries, ...items] : items;
        this.auditNextToken = page?.nextToken ?? null;
        this.auditLoaded = true;
        this.auditLoading = false;
      },
      error: (err) => {
        console.error('Fehler beim Laden des Änderungsprotokolls', err);
        this.auditLoading = false;
        this.auditLoaded = true;
      }
    });
  }

  loadMoreAudit() {
    this.fetchAudit(true);
  }

  reloadAudit() {
    this.auditNextToken = null;
    this.fetchAudit(false);
  }

  /** "2026-07-09T12:34:56.789Z#a1b2c3d4" → Date for the date pipe. */
  auditTime(occurredAt: string): Date | null {
    if (!occurredAt) return null;
    const iso = occurredAt.split('#')[0];
    const d = new Date(iso);
    return isNaN(d.getTime()) ? null : d;
  }
}
